<template lang="pug">
	modal(v-if="registro")
		.card.text-left
			.card-header.bg-info.text-white
				span.fa.fa-info.circle.mr-2
				| Detalles del registro
				button.close(@click="cerrar") &times;
			.card-body.bg-light
				.row
					.col
						h3
							span.fa.fa-user.mr-2
							| {{registro.UsuarioNombre}}
					.col.text-right
						h3 {{registro.Naturaleza}}
			.card-body
				.row
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6
						h5
							span.fa.fa-sign-in.mr-2
							| Entrada
						table.tabla
							tbody
								tr
									td.categoria Hora inicio jornada
									td.valor {{registro.FechaInicioJornada}}
								tr
									td.categoria(style="width:80px;" :class="registro.FechaInicioJornada === registro.FechaRegistroEntrada ? '' : 'text-danger'") Hora en que se ficha
									td.valor(:class="registro.FechaInicioJornada === registro.FechaRegistroEntrada ? '' : 'text-danger'") {{registro.FechaRegistroEntrada}}
								tr
									td.categoria(style="width:80px;") Dispositivo
									td.valor {{registro.TipoRegistroEntrada}}
								tr
									td.categoria(style="width:80px;") Ubicación
									td.valor
										span(v-if="registro.IPLocalEntrada") Trabajo
										span(v-else) Externa
								tr
									td.categoria(style="width:80px;") IP
									td.valor {{registro.IPEntrada}}
								tr
									td.categoria(style="width:80px;") Geolocalizado
									td.valor
										span(v-if="registro.LatitudEntrada && registro.LongitudEntrada") Sí
										span(v-else) No
								tr
									td.categoria(style="width:80px;") Usuario que registra
									td.valor {{registro.UsuarioRegistraEntradaNombre}}
								tr
									td.categoria(style="width:80px;") Comentarios
									td.valor {{registro.ComentariosEntrada}}
						
						div(id="mapaEntrada", v-if="registro.LatitudEntrada && registro.LongitudEntrada")
								
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6
						div.text-right
							h5
								| Salida
								span.fa.fa-sign-out.ml-2
						table.tabla
							tbody
								tr
									td.categoria Hora fin jornada
									td.valor {{registro.FechaFinJornada}}
								tr
									td.categoria(style="width:80px;" :class="registro.FechaFinJornada === registro.FechaRegistroSalida ? '' : 'text-danger'") Hora en que se ficha
									td.valor(:class="registro.FechaFinJornada === registro.FechaRegistroSalida ? '' : 'text-danger'") {{registro.FechaRegistroSalida}}
								tr
									td.categoria(style="width:80px;") Dispositivo
									td.valor {{registro.TipoRegistroSalida}}
								tr
									td.categoria(style="width:80px;") Ubicación
									td.valor
										span(v-if="registro.IPLocalSalida") Trabajo
										span(v-else) Externa
								tr
									td.categoria(style="width:80px;") IP
									td.valor {{registro.IPSalida}}
								tr
									td.categoria(style="width:80px;") Geolocalizado
									td.valor
										span(v-if="registro.LatitudSalida && registro.LongitudSalida") Sí
										span(v-else) No
								tr
									td.categoria(style="width:80px;") Usuario que registra
									td.valor {{registro.UsuarioRegistraSalidaNombre}}
								tr
									td.categoria(style="width:80px;") Comentarios
									td.valor {{registro.ComentariosSalida}}
						
						div(id="mapaSalida", v-if="registro.LatitudSalida && registro.LongitudSalida")
			.card-body.bg-light.text-center
				h4
					span.fa.fa-clock-o(style="font-size:2em;")
					br
					| Tiempo total
					br
					b {{registro.FechaFinJornadaUnix - registro.FechaInicioJornadaUnix | hora}}

</template>

<script>
import axios from 'axios'
export default {
	props: ['RegistroID'],
	data () {
		return {
			registro: null,
			mapaEntrada: null,
			marcadorEntrada: null,
			mapaSalida: null,
			marcadorSalida: null
		}
	},
	created () {
		this.getRegistro()
	},
	methods: {
		getRegistro () {
			axios.get('gestion-jornada/php/api/getRegistro.php?RegistroID=' + this.RegistroID)
				.then(res => {
					this.registro = res.data
					window.setTimeout(() => {
						this.initMapaEntrada()
						this.initMapaSalida()
					}, 300)
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
					this.cerrar()
				})
		},
		initMapaEntrada () {
			console.log('Vamos a por el mapa de entrada')
			if (!this.registro.LatitudEntrada || !this.registro.LongitudEntrada) {
				console.log('Sin datos de entrada')
				return
			}
			// eslint-disable-next-line
			this.mapaEntrada = new google.maps.Map(document.getElementById('mapaEntrada'), {
				center: {lat: this.registro.LatitudEntrada, lng: this.registro.LongitudEntrada},
				zoom: 16
			})

			// eslint-disable-next-line
			this.marcadorEntrada = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.registro.LatitudEntrada, this.registro.LongitudEntrada),
				title: 'Tu posición',
				map: this.mapaEntrada
			})
			console.log('Ya tenemos el mapa de entrada')
		},
		initMapaSalida () {
			if (!this.registro.LatitudSalida || !this.registro.LongitudSalida) {
				return
			}
			// eslint-disable-next-line
			this.mapaSalida = new google.maps.Map(document.getElementById('mapaSalida'), {
				center: {lat: this.registro.LatitudSalida, lng: this.registro.LongitudSalida},
				zoom: 16
			})

			// eslint-disable-next-line
			this.marcadorSalida = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.registro.LatitudSalida, this.registro.LongitudSalida),
				title: 'Tu posición',
				map: this.mapaSalida
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
table.tabla {
	position: relative;
	display: block;
	width: 100%;
	border: none;
	border-spacing: 3px;
	margin-bottom: 20px;
}
tr > td {
	border-bottom: 1px solid #f0f0f0;
	padding: 3px;
}
td.categoria {
	width: 100%;
}
td.valor {
	font-weight: bold;
	min-width: 200px;
}
#mapaEntrada {
	height: 350px;
}

#mapaSalida {
	height: 350px;
}
</style>


// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/listados/detalles.vue